module.exports = __webpack_public_path__ + "static/0036-b93df0d9dc5f8ee0075fb242d11bd6d1.png";